<template>
  <div>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Request Method</span>
      </div>
      <select v-model="data.method" class="form-control">
          <option value="get">GET</option>
          <option value="post">POST</option>
          <option value="put">PUT</option>
          <option value="delete">DELETE</option>
          <option value="patch">PATCH</option>
      </select>
    </div>
    <FormInput label="URL" :value="data.url" hint="http://" @update="data.url=$event"></FormInput>
    <CheckBox label="Add Headers" :value="data.headers_present" @change="data.headers_present=$event"></CheckBox>
    <div v-if="data.headers_present">
      <h6>Headers</h6>
      <div class="form-group">
        <textarea type="text" class="form-control" placeholder="JSON Headers" v-model="data.headers"></textarea>
      </div>
    </div>
    <div v-if="body_methods.includes(data.method)">
      <h6>Body</h6>
      <div class="form-group">
        <textarea type="text" class="form-control" placeholder="JSON Body" v-model="data.body"></textarea>
      </div>
    </div>
    <p>Magic variable 'http_result' contains this HTTP requests response. If request fails below error message will be sent.</p>
    <FormInput label="Error Message" :value="data.error" hint="Resource Not Found" @update="data.error=$event"></FormInput>
  </div>
</template>


<script>
import FormInput from '@/components/tasks/fields/FormInput.vue'
import CheckBox from '@/components/tasks/fields/CheckBox.vue'

export default {
  name: 'HttpRequest',
  components:{
    FormInput,
    CheckBox
  },
  props:{
    data: Object,
  },
  data: function() {
    return{
      body_methods: ['post', 'put', 'patch'],
    }
  }
}
</script>
